import axios from 'axios'

const base_url = `${process.env.VUE_APP_API_PATH}`;

export default {
    getAllUsers(user_email) {
        const url = `${base_url}/users/all`;

        return axios.post(url, user_email)
    },

    getUserFeedback() {
        const url = `${base_url}/users/feedback`
        return axios.get(url)
    },

    deleteUser(user){
        const url = `${base_url}/users/delete/${user.id}`
        return axios.delete(url)
    }
}
